module.exports = __webpack_public_path__ + "media/images/thumb-up-light-1bd483bad9ccce6bf6be2629812e6ebe.svg";